export default "__VITE_ASSET__512nzU_5__"